import type { PublicRuntimeConfig } from 'nuxt/schema'

export type FeatureFlag = keyof PublicRuntimeConfig['feature']

export const useIsFeatureFlagEnabled = (name: FeatureFlag) => {
  const featureFlag = useRuntimeConfig().public.feature[name]
  return String(featureFlag) === 'true'
}
